<template>
  <header class="header" :class="{ 'header--sticky': isSticky }">
    <div class="header-top">
      <!-- 로그인 전 -->
      <template v-if="checkUserId.userId == ''">
        <a :href="brochureUrl" download="ICIK_BROCHURE.pdf" class="top-link" aria-label="브로슈어 다운로드">
          Brochure
        </a>
        <span class="top-sep" aria-hidden="true">|</span>
        <button class="top-link top-link--button" @click="go('/login')">
          로그인
        </button>
      </template>

      <!-- 로그인 후 -->
      <template v-else>
        <a :href="brochureUrl" download="ICIK_BROCHURE.pdf" class="top-link" aria-label="브로슈어 다운로드">
          Brochure
        </a>
        <span class="top-sep" aria-hidden="true">|</span>
        <a class="top-link" @click.prevent="go('/mypage')">{{ checkUserId.userName }}님 어서오세요</a>
        <span class="top-sep" aria-hidden="true">|</span>
        <button class="top-link top-link--button" @click="goLogOut">로그아웃</button>
      </template>
    </div>

    <div class="nav-content">
      <!-- 로고 -->
      <router-link class="logo" to="/" aria-label="홈으로 이동">
        <img :src="logoSrc" alt="ICIK 로고" @click="goHomeHardReload" />
      </router-link>

      <nav class="nav nav--desktop" aria-label="주 메뉴">
        <ul class="menu">
          <!-- 협회 소개 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/aboutmain', query: { tab: 'intro' } })">
              협회 소개
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/aboutmain', query: { tab: 'intro' } })">협회소개</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/aboutmain', query: { tab: 'greeting' } })">협회장 인사말</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/aboutmain', query: { tab: 'history' } })">연혁</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/aboutmain', query: { tab: 'organization' } })">조직도/임원</AppButton>
              </li>
            </ul>
          </li>

          <!-- 회원 안내 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go('/membershipmain')">
              회원 안내
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go('/membershipmain')">회원 안내</AppButton>
              </li>
              <!-- <li class="submenu__item">
                <AppButton variant="text" @click="go('/membershipjoin')">가입 절차</AppButton>
              </li> -->
            </ul>
          </li>

          <!-- 자격증 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/certificationmain', query: { tab: 'cics' } })">자격
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/certificationmain', query: { tab: 'cics' } })">국제공인 내부통제사</AppButton>
                <!-- <AppButton variant="text" @click="go('/certification')">국제공인 내부통제사</AppButton> -->

              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/certificationmain', query: { tab: 'cicp' } })">국제공인 전문내부통제사</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/certificationmain', query: { tab: 'exam' } })">시험 접수</AppButton>
              </li>
            </ul>
          </li>

          <!-- 교육/워크숍 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go('/trainingmain')">교육 / 워크숍
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go('/trainingmain')">교육안내</AppButton>
              </li>
            </ul>
          </li>

          <!-- 내부통제인증 -->
          <li class="menu__item">
            <!-- 상위 버튼 -->
            <AppButton variant="text" @click="go('/iiccmain/selfassessment/surveypublic')">
              진단 / 인증
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>

            <!-- 서브메뉴 -->
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go('/iiccmain/selfassessment/surveypublic')">
                  지배구조 진단
                </AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go('/iiccmain')">
                  내부통제 진단
                </AppButton>
              </li>

              <li class="submenu__item">
                <AppButton variant="text" @click="go('/iiccmain/certification')">
                  내부통제 국제인증
                </AppButton>
              </li>
            </ul>
          </li>


          <!-- 주요행사 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/newsmain', query: { tab: 'news' } })">주요행사
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/newsmain', query: { tab: 'news' } })">협회소식</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/newsmain', query: { tab: 'events' } })">주요행사</AppButton>
              </li>
            </ul>
          </li>

          <!-- 자료실 -->
          <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'archivemain' } })">자료실
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'dictionary' } })">내부통제 용어 및 정의
                </AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'archive' } })">내부통제 전문자료
                </AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'archivetree' } })">유형별 통제 매트릭스 사전
                </AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'expertmain' } })">전문가 칼럼
                </AppButton>
              </li>
            </ul>
          </li>

          <!-- Q&A -->
          <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/qnamain', query: { tab: 'qna' } })">Contact
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/qnamain', query: { tab: 'qna' } })">Contact Us</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/qnamain', query: { tab: 'faq' } })">FAQ</AppButton>
              </li>
            </ul>
          </li>

          <!-- AII -->
          <!-- <li class="menu__item">
            <AppButton variant="text" @click="go({ path: '/aichat', query: { tab: 'aichat' } })">AI
              <i class="fa-solid fa-chevron-down caret" aria-hidden="true"></i>
            </AppButton>
            <ul class="submenu">
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/aichat', query: { tab: 'aichat' } })">AI</AppButton>
              </li>
              <li class="submenu__item">
                <AppButton variant="text" @click="go({ path: '/Auditstatsdashboard', query: { tab: 'events' } })">통계</AppButton>
              </li>
            </ul>
          </li> -->
        </ul>
      </nav>

      <!-- 모바일 토글 버튼 -->
      <button class="nav-toggle mobile-only" :aria-expanded="mobileOpen ? 'true' : 'false'" aria-controls="mobile-menu"
        @click="mobileOpen = !mobileOpen">
        <span class="sr-only">메뉴 열기</span>
        <i class="fa-solid" :class="mobileOpen ? 'fa-xmark' : 'fa-bars'"></i>
      </button>
    </div>

    <!-- 모바일 메뉴 -->
    <nav id="mobile-menu" class="nav--mobile" aria-label="모바일 주 메뉴" v-show="mobileOpen">
      <ul class="m-menu">
        <!-- 협회 소개 -->
        <li class="m-item">
          <button class="m-parent" :id="`m-parent-0`" :aria-controls="`m-sub-0`"
            :aria-expanded="mOpenIndex === 0 ? 'true' : 'false'" @click="toggleMobile(0)">
            <span>협회 소개</span>
            <i class="fa-solid" :class="mOpenIndex === 0 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 0">
            <li><button class="m-link" @click="goClose({ path: '/aboutmain', query: { tab: 'intro' } })">협회소개</button>
            </li>
            <li><button class="m-link" @click="goClose({ path: '/aboutmain', query: { tab: 'greeting' } })">협회장
                인사말</button>
            </li>
            <li><button class="m-link" @click="goClose({ path: '/aboutmain', query: { tab: 'history' } })">연혁</button>
            </li>
            <li><button class="m-link"
                @click="goClose({ path: '/aboutmain', query: { tab: 'organization' } })">조직도/임원</button></li>
          </ul>
        </li>

        <!-- 회원 안내 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 1 ? 'true' : 'false'" @click="toggleMobile(1)">
            <span>회원 안내</span>
            <i class="fa-solid" :class="mOpenIndex === 1 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 1">
            <li><button class="m-link" @click="goClose('/membershipmain')">회원 안내</button></li>
          </ul>
        </li>

        <!-- 자격증 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 2 ? 'true' : 'false'" @click="toggleMobile(2)">
            <span>자격증</span>
            <i class="fa-solid" :class="mOpenIndex === 2 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 2">
            <li><button class="m-link" @click="goClose({ path: '/certificationmain', query: { tab: 'cics' } })">국제공인내부통제사</button></li>
            <li><button class="m-link" @click="goClose({ path: '/certificationmain', query: { tab: 'cicp' } })">국제공인 전문내부통제사</button></li>
            <li><button class="m-link" @click="goClose({ path: '/certificationmain', query: { tab: 'exam' } })">시험접수</button></li>
          </ul>
        </li>

        <!-- 교육/워크숍 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 3 ? 'true' : 'false'" @click="toggleMobile(3)">
            <span>교육 / 워크숍</span>
            <i class="fa-solid" :class="mOpenIndex === 3 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 3">
            <li><button class="m-link" @click="goClose('/trainingmain')">교육안내</button></li>
          </ul>
        </li>

        <!-- 내부통제인증 -->
        <!-- <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 4 ? 'true' : 'false'" @click="toggleMobile(4)">
            <span>인증 / 진단 </span>
            <i class="fa-solid" :class="mOpenIndex === 4 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 4">
            <li>
              <button class="m-link" @click="go('/iiccmain/selfassessment/surveypublic')">지배구조 진단</button>
            </li>
            <li><button class="m-link"  @click="go('/iiccmain')" >내부통제 진단</button>
            </li>
            <li><button class="m-link"  @click="go('/iiccmain/certification')" >내부통제 인증</button>
            </li>
          </ul>
        </li> -->
        <!-- 인증 / 진단 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 4 ? 'true' : 'false'" @click="toggleMobile(4)">
            <span>인증 / 진단</span>
            <i class="fa-solid" :class="mOpenIndex === 4 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>

          <ul class="m-sub" v-show="mOpenIndex === 4">
            <li>
              <button
                class="m-link"
                @click="goClose({ path: '/iiccmain/selfassessment/surveypublic', query: { tab: 'surveypublic' } })"
              >
                지배구조 진단
              </button>
            </li>

            <li>
              <button
                class="m-link"
                @click="goClose({ path: '/iiccmain', query: { tab: 'internalaudit' } })"
              >
                내부통제 진단
              </button>
            </li>

            <li>
              <button
                class="m-link"
                @click="goClose({ path: '/iiccmain/certification', query: { tab: 'certification' } })"
              >
                내부통제 국제인증
              </button>
            </li>
          </ul>
        </li>


        <!-- 주요행사 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 5 ? 'true' : 'false'" @click="toggleMobile(5)">
            <span>주요행사</span>
            <i class="fa-solid" :class="mOpenIndex === 5 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 5">
            <li><button class="m-link" @click="goClose({ path: '/newsmain', query: { tab: 'news' } })">협회소식</button>
            </li>
            <li><button class="m-link" @click="goClose({ path: '/newsmain', query: { tab: 'events' } })">주요행사</button>
            </li>
          </ul>
        </li>

        <!-- 자료실 -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 6 ? 'true' : 'false'" @click="toggleMobile(6)">
            <span>자료실</span>
            <i class="fa-solid" :class="mOpenIndex === 6 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 6">
            <li class="submenu__item">
              <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'dictionary' } })">내부통제 용어 및 정의
              </AppButton>
            </li>
            <li class="submenu__item">
              <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'archive' } })">내부통제 전문자료
              </AppButton>
            </li>
            <li class="submenu__item">
              <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'archivetree' } })">유형별 통제 매트릭스 사전
              </AppButton>
            </li>
            <li class="submenu__item">
              <AppButton variant="text" @click="go({ path: '/archivemain', query: { tab: 'expertmain' } })">전문가 칼럼
              </AppButton>
            </li>
          </ul>
        </li>

        <!-- Contact -->
        <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 7 ? 'true' : 'false'" @click="toggleMobile(7)">
            <span>Contact</span>
            <i class="fa-solid" :class="mOpenIndex === 7 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 7">
            <li><button class="m-link" @click="goClose({ path: '/qnamain', query: { tab: 'qna' } })">Contact Us</button></li>
            <li><button class="m-link" @click="goClose({ path: '/qnamain', query: { tab: 'faq' } })">FAQ</button></li>
          </ul>
        </li>

        
        <!-- AII -->
        <!-- <li class="m-item">
          <button class="m-parent" :aria-expanded="mOpenIndex === 8 ? 'true' : 'false'" @click="toggleMobile(8)">
            <span>AI</span>
            <i class="fa-solid" :class="mOpenIndex === 8 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <ul class="m-sub" v-show="mOpenIndex === 8">
            <li><button class="m-link" @click="goClose({ path: '/aichat', query: { tab: 'aichat' } })">AI</button>
            </li>
            <li><button class="m-link" @click="goClose({ path: '/Auditstatsdashboard', query: { tab: 'events' } })">통계</button>
            </li>
          </ul>
        </li> -->

      </ul>
    </nav>
  </header>
</template>

<script setup>
import logoSrc from '@/assets/HeaderICIK.png'
import AppButton from '@/components/ui/AppButton.vue'
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter()
const checkUserId = computed(() => store.state.temp.userInfo)

// ==== UI 상태 ====
const mobileOpen = ref(false)     // 모바일 메뉴 전체 열림/닫힘
const mOpenIndex = ref(null)      // 모바일 아코디언 열린 인덱스

const isSticky = ref(false)       // 스크롤 시 헤더 그림자

// 로그인 여부 (실제로는 Vuex, Pinia, composable 등에서 가져올 수도 있음)
// const isLoggedIn = ref(false)

//function logout() {
  // 로그아웃 처리 로직 (토큰 삭제, 세션 종료 등)
  // 예시:
  // authStore.logout()
//  isLoggedIn.value = false
//  router.push('/')   // 로그아웃 후 메인으로
//}

function goHomeHardReload() {
  window.location.assign('/')   // 또는 window.location.href = '/'
}

// ==== 내비게이션 ====
function go(to) {                 // 문자열/라우트 객체 모두 호환
  router.push(to)
}
function goClose(to) {            // 모바일 메뉴에서 이동 후 닫기
  router.push(to)
  mobileOpen.value = false
  mOpenIndex.value = null
}
function toggleMobile(i) {        // 아코디언 토글
  mOpenIndex.value = mOpenIndex.value === i ? null : i
}

// ==== 스크롤 영향 ====
function onScroll() {
  isSticky.value = window.scrollY > 4
}

const goLogOut = () => {
  // 실제 로직으로 교체
  if (confirm("로그아웃 하시겠습니까?")) {
    store.commit('temp/clearUserInfo')
    store.commit('grid/clearSearchParam')
    router.push('/')
  }
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  // console.log("123123")
})
onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})

// 기존 그대로 사용
const brochureUrl = '/brochure/ICIK_2026.pdf'
</script>


<style scoped>
/* =========================
   HEADER (최종 정리본)
   클릭 후 마우스가 빠지면 메뉴 닫힘
   ========================= */

/* === 공통 레이아웃 === */
.header {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-bottom: 1px solid #ddd;
}

/* 상단 얇은 바(로그인/마이페이지 등) */
.header-top {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #edeff3;
  font-size: 13px;
  line-height: 1;
}

.top-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #111;
  text-decoration: none;
  cursor: pointer;
  font-family: 'Noto Sans KR', sans-serif;
}

.top-link:hover {
  text-decoration: underline;
  color: #1d2088;
}

.top-link--button {
  padding: 0;
  border: none;
  background: transparent;
  font-family: 'Noto Sans KR', sans-serif;
}

.top-sep {
  color: #cbd5e1;
}

/* 메인 내비 행 */
.nav-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  /* [로고] [가운데] [우측] */
  align-items: center;
  column-gap: 16px;

  width: 100%;
  padding: 6px 0;
  background: #fff;
}

/* 로고(왼쪽 고정) */
.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 100px;
  display: block;
  cursor: pointer;
}

/* sticky 시 그림자 */
.header--sticky {
  box-shadow: 0 4px 14px rgba(17, 24, 39, .06);
  border-bottom-color: transparent;
}

/* 접근성: 화면낭독 전용 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* 가운데 네비: 진짜 화면 중앙 정렬 */
.nav--desktop {
  justify-self: center;
  /* 컬럼 너비와 무관하게 중앙 고정 */
}

.menu {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: .75rem 1.25rem;
}

.menu__item {
  position: relative;
}

/* 상위 버튼 스타일(:deep은 Vue 컴포넌트 경계 넘기용) */
.menu__item> :deep(.btn--text) {
  position: relative;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: .2px;
  color: #111;
  padding: .75rem .25rem;
  border-radius: 8px;
}

/* 상위 버튼 하단 밑줄 애니메이션 */
.menu__item> :deep(.btn--text)::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: .35rem;
  margin: 0 auto;
  width: 0%;
  height: 2px;
  background: #1d2088;
  border-radius: 2px;
  transition: width .22s ease;
}

/* 서브메뉴 (기본 숨김) */
/* .submenu {
  position: absolute;
  left: 100%;
  transform: translate(-50%, 6px);
  min-width: 220px;
  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 12px;
  padding: .5rem;
  box-shadow: 0 12px 30px rgba(17, 24, 39, .08),
    0 3px 8px rgba(17, 24, 39, .05);
  z-index: 1040;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity .18s ease,
    transform .18s ease,
    visibility 0s linear .22s;
} */

.submenu {
  position: absolute;
  left: 0;                     /* ⭐ 부모 기준 왼쪽 정렬 */
  top: 100%;

  width: max-content;          /* 글자 길이에 맞게 */
  white-space: nowrap;

  margin-top: 6px;             /* 기존 translateY 대신 */

  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 12px;
  padding: .5rem;
  box-shadow: 0 12px 30px rgba(17, 24, 39, .08),
              0 3px 8px rgba(17, 24, 39, .05);
  z-index: 1040;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity .18s ease,
    transform .18s ease,
    visibility 0s linear .22s;
}

/* 서브메뉴 항목 */
.submenu__item {
  margin: .125rem 0;
}

.submenu__item :deep(.btn--text) {
  display: block;
  width: 100%;
  text-align: left;
  color: #111;
  padding: .6rem .75rem;
  border-radius: 10px;
  font-weight: 500;
  font-size: .95rem;
}

.submenu__item :deep(.btn--text:hover),
.submenu__item :deep(.btn--text:focus-visible) {
  background: rgba(29, 32, 136, .06);
  color: #1d2088;
  outline: none;
}

/* === 상태/효과 === */

/* 캐럿(▼) 아이콘 */
.caret {
  font-size: .75rem;
  color: #666;
  transition: transform .2s ease, color .2s ease;
}

.menu__item:hover .caret {
  transform: translateY(2px) rotate(180deg);
  color: #1d2088;
}

/* 열림 조건: hover 또는 키보드 focus-visible */
/* .menu__item:hover .submenu,
.menu__item:has(> :focus-visible) .submenu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translate(-50%, 0);
  transition-delay: 0s, 0s, 0s;
} */

.menu__item:hover .submenu,
.menu__item:has(> :focus-visible) .submenu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);   /* 혹은 그냥 삭제해도 됨 */
  transition-delay: 0s, 0s, 0s;

}

/* 밑줄 효과도 동일 조건으로 */
.menu__item:hover> :deep(.btn--text)::after,
.menu__item:has(> :focus-visible)> :deep(.btn--text)::after {
  width: 100%;
}

/* 드롭다운 사이 마우스 이동용 가드 영역 */
.menu__item::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  height: 10px;
}

/* 포커스 outline */
.menu__item> :deep(.btn--text:focus-visible),
.nav-toggle:focus-visible,
.m-parent:focus-visible {
  outline: 3px solid rgba(29, 32, 136, .25);
  outline-offset: 2px;
}

/* === 반응형 (≤1100px) === */
.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

@media (max-width: 1200px) {
  .logo img {
    height: 64px;
  }

  .nav-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* padding: 6px 14px; */
  }

  .nav--desktop,
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: inline-flex;
  }

  /* 햄버거 버튼 */
  .nav-toggle {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background: #fff;
    margin-right: 30px;
  }

  /* ===== 모바일 내비 (리디자인: 붙여넣기용 전체) ===== */

  /* 패널 */
  .nav--mobile {
    border-top: 1px solid #e6e9f0;
    background: #fff;
    padding: 10px 12px 18px;
    z-index: 1050;
  }

  /* 리스트 래핑: 카드 간격 */
  .m-menu {
    display: grid;
    gap: 10px;
    max-width: 100%;
    margin: 0 auto;
  }

  /* 카드 */
  .m-item {
    border: 1px solid #e8ebf2;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 10px rgba(17, 24, 39, .04);
  }

  /* 헤더 버튼 */
  .m-parent {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 15px 16px;
    background: #fff;
    border: 0;
    cursor: pointer;
    min-height: 48px;
    font-weight: 700;
    font-size: 15px;
    color: #0f172a;
  }

  /* 포커스 가시화 */
  .m-parent:focus-visible {
    outline: 3px solid rgba(29, 32, 136, .25);
    outline-offset: 3px;
    border-radius: 12px;
  }

  /* 헤더 hover */
  .m-parent:hover {
    background: linear-gradient(0deg, rgba(29, 32, 136, .03), rgba(29, 32, 136, .03)), #fff;
  }

  /* 캐럿 아이콘: 기본 상태 */
  .m-parent .fa-solid {
    font-size: 14px;
    color: #64748b;
    transition: transform .22s ease, color .22s ease, opacity .22s ease;
  }

  /* 열림(aria-expanded=true) 상태 */
  .m-parent[aria-expanded="true"] {
    background: #f8fafc;
    border-bottom: 1px dashed #e5e7eb;
  }

  .m-parent[aria-expanded="true"] .fa-solid {
    transform: rotate(180deg);
    color: #1d2088;
  }

  /* 아코디언 콘텐츠(슬라이드다운 애니메이션) */
  .m-sub {
    display: block;
    /* v-show로 토글됨을 가정 */
    padding: 0 12px 12px;
    border-top: 1px dashed #e5e7eb;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transform-origin: top;
    transition: max-height .26s ease, opacity .18s ease;
  }

  /* aria-expanded와 동기화하여 시각 트랜지션 제공 */
  .m-parent[aria-expanded="true"]+.m-sub {
    max-height: 600px;
    /* 충분히 큰 값 */
    opacity: 1;
  }

  /* 링크(행) */
  .m-link {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 12px;
    margin-top: 8px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid transparent;
    font-size: 14px;
    font-weight: 500;
    color: #0f172a;
    min-height: 44px;
    /* 터치 타겟 */
    transition: background .18s ease, border-color .18s ease, transform .12s ease;
  }

  /* 링크 hover/active/keyboard */
  .m-link:hover,
  .m-link:focus-visible {
    background: rgba(29, 32, 136, .06);
    border-color: rgba(29, 32, 136, .12);
    outline: none;
  }

  .m-link:active {
    transform: translateY(1px);
  }

  /* 마지막 간격 보정 */
  .m-sub .m-link:last-child {
    margin-bottom: 4px;
  }
}

/* 초소형 보정(≤480px) */
@media (max-width: 480px) {
  .nav--mobile {
    padding: 8px 10px 14px;
  }

  .m-menu {
    gap: 8px;
  }

  .m-parent {
    padding: 14px 14px;
    font-size: 14.5px;
  }

  .m-link {
    padding: 11px 10px;
  }
}

/* 모션 최소화 */
@media (prefers-reduced-motion: reduce) {

  .m-parent .fa-solid,
  .m-sub,
  .m-link {
    transition: none !important;
  }
}

/* 데스크톱 폭 이상에서는 모바일 패널 강제 비표시 */
@media (min-width: 1200px) {
  #mobile-menu {
    display: none !important;
  }
}

/* (선택) 스크롤 잠금에 썼다면 함께 정의 */
.no-scroll {
  overflow: hidden;
}



</style>